export default __webpack_public_path__ + "static/media/share.6af48bff.svg";